import { z } from 'zod';
import { isArray } from '@borg/utils';

export const queryString = {
  number: z.union([z.string(), z.array(z.string())]).transform((val) => {
    return isArray(val) ? Number(val[0]) : Number(val);
  }),
  string: z.union([z.string(), z.array(z.string())]).transform((val) => {
    return isArray(val) ? val[0] : val;
  }),
  numberArray: z.union([z.string(), z.array(z.string())]).transform((val) => {
    return isArray(val) ? val.map(Number) : [Number(val)];
  }),
  stringArray: z.union([z.string(), z.array(z.string())]).transform((val) => {
    return isArray(val) ? val.map(String) : [String(val)];
  }),
};
